// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../assets/open-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../../assets/clock.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../../assets/user.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../../assets/target.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../../assets/align-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../../assets/close.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addSession{  
    /*background-color: #f9f9f9;*/
    background-color: #f9f9f6;
    width: 100%;
    height: 100%;
    padding-top: 43px;
    padding-left: 30px;
    padding-right: 56px;
    padding-bottom: 30px;
}

.addSession_topMenu{
    /*margin-bottom: 43px;*/
}

.addSession_header{
    display: flex;
    justify-content: space-between;
    margin-left: 44px;
    margin-bottom: 12px;
}

.addSession_title{
    font-weight: 400;
    font-size: calc(14px * var(--fontScaler));
    line-height: 19px;

    color: #8E9ABB;
}

.addSession_addTitle{
    margin-bottom: 25px;
    margin-left: 44px;
    font-weight: 400;
    font-size: calc(24px * var(--fontScaler));
    line-height: 33px;
    border-bottom: 1px solid rgba(152, 159, 201, 0.12);
    display: flex;
    align-items: center;
}

.addSession_addTitle_input{
    display: block;
    width: 100%;
    background-color: transparent;
    border: none;
    font-weight: inherit;
    font-size: inherit;
    font-family: inherit;
}

.addSession_formItem{
    display: flex;
    align-items: flex-start;
    gap: 22px;
}

.addSession_formItem_content{
    padding-top: 2px;
    font-weight: 400;
    font-size: calc(14px * var(--fontScaler));
    line-height: 19px;

    color: #757575;
}

.addSession_formItem_content{
    .commonDropDown{
        margin-left: -5px;
        height: 22px;
    }
    
    .commonDropDown_wrap{
        background: #fff;
        border-radius: 5px;
    }
    
    .commonDropDown--opened{
    }
    
    .commonDropDown_header{
        background: #fff;
        border-radius: 30px;
    
        font-weight: 700;
        font-size: calc(14px * var(--fontScaler));
        line-height: 19px;
    
        color: #757575;

        height: auto;
        padding: 4px 5px;
    }
    
    .commonDropDown_value{
    
    }
    
    .commonDropDown_arrow{
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    }
    
    .commonDropDown_list_wrap{
        font-weight: 400;
        font-size: calc(14px * var(--fontScaler));
        line-height: 19px;
    
        color: #757575;
    }
    
    .commonDropDown--opened .commonDropDown_list_wrap{
    }

    .commonDropDown--opened .commonDropDown_wrap{
        box-shadow: 0px 0px 15px #0002;
        z-index: 10;
    }
    
    .commonDropDown_list{
    }
    
    .commonDropDown_item{
        padding: 4px 5px;
    }
    
    .commonDropDown_item:hover{
        padding: 4px 5px;
        background-color: #F3F6FF;
    }    
}

.addSession_buttons{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 26px;
}

.addSession_draft{
    font-style: italic;
    font-weight: 400;
    font-size: calc(14px * var(--fontScaler));
    line-height: 19px;
    text-decoration-line: underline;

    color: #8E9ABB;
}

.addSession_save{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 40px;
    gap: 10px;

    background: #FFA825;
    border-radius: 24px;
}

.addSession_form{
    background: #FFFFFF;
    box-shadow: 0px 4px 31.4423px rgba(202, 196, 208, 0.15);
    border-radius: 24px;
    padding: 28px;

    height: 100%;
    /*overflow: auto;*/

    display: flex;
    flex-direction: column;
}

.addSession_scrollWrap{
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex-grow: 1;
}

.addSession_goodScroll{
    --gradientColor: #fff;
    --gradientEmptyColor: #fff0;
}

.addSession_inputs{
    display: flex;
    flex-direction: column;
    gap: 26px;
    flex-grow: 1;
    margin-bottom: 20px;
    padding-bottom: 10px;
    /*margin-bottom: 107px;*/
}

.addSession_icon{
    width: 22px;
    height: 22px;
    border: none;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}
.addSession_time_icon{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.addSession_user_icon{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.addSession_task_icon{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.addSession_description_icon{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.addSession_close_icon{
    width: 17px;
    height: 17px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.addSession_formItem_content--date{
    display: flex;
    gap: 10px
}

.addSession_formItem_line{
    display: flex;
    gap: 10px;
    align-items: flex-end;
}

.addSession_input{
    border-radius: 3px;
    border: 1px solid #F3F6FF;
}

.addSession_input:focus{
    outline: 0;
    border: 1px solid #8E9ABB;
}

.addSession_dateBlock{
    position: relative;
}

.addSession_dateOutput{

}

.addSession_dateInput{
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
}

.addSession_dateInput:focus{
    opacity: 1;
}

.addSession_error{
    color: #E23424;
}

.addSession_timeField {
    cursor: pointer;
    position: relative;
    user-select: none;
}

.addSession_timeField_label {
    transition: opacity 0.15s;
}

.addSession_timeField:hover .addSession_timeField_label {
    opacity: 0.55;
}

.addSession_timeField_popup {
    position: absolute;
    top: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    z-index: 200;
    background: #ffffff;
    border-radius: 14px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);
    padding: 12px 8px;
    display: flex;
    align-items: center;
}

.addSession_timeField_popup .commonSelectTime {
    border: none;
    box-shadow: none;
    border-radius: 0;
}

.addSession_timeField_popup .commonSelectTime_selectionBorder {
    border-color: rgba(0, 0, 0, 0.08);
    border-radius: 8px;
}

.addSession_timeField_popup .commonSelectTime_scrollList_items {
    border-radius: 8px;
    background: #f8f8f8;
}

.addSession_timeField_popup .commonSelectTime_scrollList_item {
    background: transparent;
    font-size: calc(13px * var(--fontScaler));
}

.addSession_timeField_popup .commonSelectTime_scrollList_item:hover {
    background: rgba(0, 0, 0, 0.04);
    border-radius: 6px;
}

.addSession_timeField_popup .commonSelectTime_scrollList_collapser {
    height: var(--item-height);
}

.addSession_timeField_popup .commonSelectTime_scrollList_collapser > .commonSelectTime_scrollList_item:nth-child(4) {
    font-weight: 600;
    color: #1a1a1a;
    font-size: calc(15px * var(--fontScaler));
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sessions/addSession/AddSession.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;;IAEjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,kDAAkD;IAClD,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,6BAA6B;IAC7B,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;;IAEjB,cAAc;AAClB;;AAEA;IACI;QACI,iBAAiB;QACjB,YAAY;IAChB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;IACA;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;;QAEnB,gBAAgB;QAChB,yCAAyC;QACzC,iBAAiB;;QAEjB,cAAc;;QAEd,YAAY;QACZ,gBAAgB;IACpB;;IAEA;;IAEA;;IAEA;QACI,yDAA6D;IACjE;;IAEA;QACI,gBAAgB;QAChB,yCAAyC;QACzC,iBAAiB;;QAEjB,cAAc;IAClB;;IAEA;IACA;;IAEA;QACI,8BAA8B;QAC9B,WAAW;IACf;;IAEA;IACA;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,yBAAyB;IAC7B;AACJ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,+BAA+B;;IAE/B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;;IAET,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,uDAAuD;IACvD,mBAAmB;IACnB,aAAa;;IAEb,YAAY;IACZ,kBAAkB;;IAElB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;AAC5B;AACA;IACI,yDAAwD;AAC5D;;AAEA;IACI,yDAAuD;AAC3D;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,yDAA6D;AACjE;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAAwD;AAC5D;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;AAEA;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,yEAAyE;IACzE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,yCAAyC;AAC7C","sourcesContent":[".addSession{  \n    /*background-color: #f9f9f9;*/\n    background-color: #f9f9f6;\n    width: 100%;\n    height: 100%;\n    padding-top: 43px;\n    padding-left: 30px;\n    padding-right: 56px;\n    padding-bottom: 30px;\n}\n\n.addSession_topMenu{\n    /*margin-bottom: 43px;*/\n}\n\n.addSession_header{\n    display: flex;\n    justify-content: space-between;\n    margin-left: 44px;\n    margin-bottom: 12px;\n}\n\n.addSession_title{\n    font-weight: 400;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 19px;\n\n    color: #8E9ABB;\n}\n\n.addSession_addTitle{\n    margin-bottom: 25px;\n    margin-left: 44px;\n    font-weight: 400;\n    font-size: calc(24px * var(--fontScaler));\n    line-height: 33px;\n    border-bottom: 1px solid rgba(152, 159, 201, 0.12);\n    display: flex;\n    align-items: center;\n}\n\n.addSession_addTitle_input{\n    display: block;\n    width: 100%;\n    background-color: transparent;\n    border: none;\n    font-weight: inherit;\n    font-size: inherit;\n    font-family: inherit;\n}\n\n.addSession_formItem{\n    display: flex;\n    align-items: flex-start;\n    gap: 22px;\n}\n\n.addSession_formItem_content{\n    padding-top: 2px;\n    font-weight: 400;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 19px;\n\n    color: #757575;\n}\n\n.addSession_formItem_content{\n    .commonDropDown{\n        margin-left: -5px;\n        height: 22px;\n    }\n    \n    .commonDropDown_wrap{\n        background: #fff;\n        border-radius: 5px;\n    }\n    \n    .commonDropDown--opened{\n    }\n    \n    .commonDropDown_header{\n        background: #fff;\n        border-radius: 30px;\n    \n        font-weight: 700;\n        font-size: calc(14px * var(--fontScaler));\n        line-height: 19px;\n    \n        color: #757575;\n\n        height: auto;\n        padding: 4px 5px;\n    }\n    \n    .commonDropDown_value{\n    \n    }\n    \n    .commonDropDown_arrow{\n        background-image: url('../../../../../assets/open-arrow.svg');\n    }\n    \n    .commonDropDown_list_wrap{\n        font-weight: 400;\n        font-size: calc(14px * var(--fontScaler));\n        line-height: 19px;\n    \n        color: #757575;\n    }\n    \n    .commonDropDown--opened .commonDropDown_list_wrap{\n    }\n\n    .commonDropDown--opened .commonDropDown_wrap{\n        box-shadow: 0px 0px 15px #0002;\n        z-index: 10;\n    }\n    \n    .commonDropDown_list{\n    }\n    \n    .commonDropDown_item{\n        padding: 4px 5px;\n    }\n    \n    .commonDropDown_item:hover{\n        padding: 4px 5px;\n        background-color: #F3F6FF;\n    }    \n}\n\n.addSession_buttons{\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 26px;\n}\n\n.addSession_draft{\n    font-style: italic;\n    font-weight: 400;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 19px;\n    text-decoration-line: underline;\n\n    color: #8E9ABB;\n}\n\n.addSession_save{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px 40px;\n    gap: 10px;\n\n    background: #FFA825;\n    border-radius: 24px;\n}\n\n.addSession_form{\n    background: #FFFFFF;\n    box-shadow: 0px 4px 31.4423px rgba(202, 196, 208, 0.15);\n    border-radius: 24px;\n    padding: 28px;\n\n    height: 100%;\n    /*overflow: auto;*/\n\n    display: flex;\n    flex-direction: column;\n}\n\n.addSession_scrollWrap{\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    flex-grow: 1;\n}\n\n.addSession_goodScroll{\n    --gradientColor: #fff;\n    --gradientEmptyColor: #fff0;\n}\n\n.addSession_inputs{\n    display: flex;\n    flex-direction: column;\n    gap: 26px;\n    flex-grow: 1;\n    margin-bottom: 20px;\n    padding-bottom: 10px;\n    /*margin-bottom: 107px;*/\n}\n\n.addSession_icon{\n    width: 22px;\n    height: 22px;\n    border: none;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n}\n.addSession_time_icon{\n    background-image: url(\"../../../../../assets/clock.svg\");\n}\n\n.addSession_user_icon{\n    background-image: url(\"../../../../../assets/user.svg\");\n}\n\n.addSession_task_icon{\n    background-image: url(\"../../../../../assets/target.svg\");\n}\n\n.addSession_description_icon{\n    background-image: url(\"../../../../../assets/align-left.svg\");\n}\n\n.addSession_close_icon{\n    width: 17px;\n    height: 17px;\n    background-image: url(\"../../../../../assets/close.svg\");\n}\n\n.addSession_formItem_content--date{\n    display: flex;\n    gap: 10px\n}\n\n.addSession_formItem_line{\n    display: flex;\n    gap: 10px;\n    align-items: flex-end;\n}\n\n.addSession_input{\n    border-radius: 3px;\n    border: 1px solid #F3F6FF;\n}\n\n.addSession_input:focus{\n    outline: 0;\n    border: 1px solid #8E9ABB;\n}\n\n.addSession_dateBlock{\n    position: relative;\n}\n\n.addSession_dateOutput{\n\n}\n\n.addSession_dateInput{\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0;\n}\n\n.addSession_dateInput:focus{\n    opacity: 1;\n}\n\n.addSession_error{\n    color: #E23424;\n}\n\n.addSession_timeField {\n    cursor: pointer;\n    position: relative;\n    user-select: none;\n}\n\n.addSession_timeField_label {\n    transition: opacity 0.15s;\n}\n\n.addSession_timeField:hover .addSession_timeField_label {\n    opacity: 0.55;\n}\n\n.addSession_timeField_popup {\n    position: absolute;\n    top: calc(100% + 8px);\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 200;\n    background: #ffffff;\n    border-radius: 14px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);\n    padding: 12px 8px;\n    display: flex;\n    align-items: center;\n}\n\n.addSession_timeField_popup .commonSelectTime {\n    border: none;\n    box-shadow: none;\n    border-radius: 0;\n}\n\n.addSession_timeField_popup .commonSelectTime_selectionBorder {\n    border-color: rgba(0, 0, 0, 0.08);\n    border-radius: 8px;\n}\n\n.addSession_timeField_popup .commonSelectTime_scrollList_items {\n    border-radius: 8px;\n    background: #f8f8f8;\n}\n\n.addSession_timeField_popup .commonSelectTime_scrollList_item {\n    background: transparent;\n    font-size: calc(13px * var(--fontScaler));\n}\n\n.addSession_timeField_popup .commonSelectTime_scrollList_item:hover {\n    background: rgba(0, 0, 0, 0.04);\n    border-radius: 6px;\n}\n\n.addSession_timeField_popup .commonSelectTime_scrollList_collapser {\n    height: var(--item-height);\n}\n\n.addSession_timeField_popup .commonSelectTime_scrollList_collapser > .commonSelectTime_scrollList_item:nth-child(4) {\n    font-weight: 600;\n    color: #1a1a1a;\n    font-size: calc(15px * var(--fontScaler));\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
